import { CommonModule } from '@angular/common';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import { SingleDatePickerModule } from 'NewAngular/features/components/date-controls/single-date-picker/single-date-picker.module';
import { SimpleDropdownModule } from 'NewAngular/features/components/dropdowns/simple-dropdown/simple-dropdown.module';
import { LoadingSymbolModule } from 'NewAngular/features/components/loaders/loading-symbol/loading-symbol.module';
import * as i0 from "@angular/core";
export class YieldCurveModule {
}
YieldCurveModule.ɵfac = function YieldCurveModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || YieldCurveModule)(); };
YieldCurveModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: YieldCurveModule });
YieldCurveModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, FeatureNeededModule, LoadingSymbolModule, SimpleDropdownModule, SingleDatePickerModule] });
